export default __webpack_public_path__ + "static/media/jackpot.b36edc36.webp";